import { render, staticRenderFns } from "./WallNameForm.vue?vue&type=template&id=0d2f8cb6&"
import script from "./WallNameForm.vue?vue&type=script&lang=js&"
export * from "./WallNameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports